import { IBaseArangoModel } from '@/bundles/App/interfaces/IBaseArangoModel';
import { IDetails } from '@/bundles/Property/interfaces/IDetails';
import { ICompany } from '@/bundles/Companies/types';
import { Nullable } from '@/utils/types';
import { IOccupierLease } from '@/bundles/Occupier/interfaces/IOccupierLease';
import { IOccupierLocation } from '@/bundles/Occupier/interfaces/IOccupierLocation';
import { IPermissions } from '@/bundles/App/interfaces/IPermissions';
import { IProperty } from '@/bundles/Property/interfaces/IProperty';
import { IOccupierSite } from '@/bundles/Occupier/interfaces/IOccupierSite';
import { IUseType } from '@/bundles/UseType/types';
import { IOccupierContact } from '@/bundles/Occupier/interfaces/IOccupierContact';
import { IOccupierOfRecord } from '@/bundles/Occupier/interfaces/IOccupierOfRecord';
import { IOccupierSchedule, IOccupierSchedulePeriod } from '@/bundles/Occupier/interfaces/IOccupierSchedule';
import { OccupancyTypeEnum } from '@/bundles/Occupiers/types';
import { IOccupierAddress } from '@/bundles/Occupier/interfaces/IOccupierAddress';
import { OccupierTplTypeEnum } from '@/bundles/Occupier/types';

export * from './IOccupierAddress';
export * from './IOccupierContact';
export * from './IOccupierLease';
export * from './IOccupierLocation';
export * from './IOccupierOfRecord';
export * from './IOccupiersCardFilters';
export * from './IOccupierSchedule';
export * from './IOccupierSite';
export * from './merge/index';

export enum OccupierRentType {
  per_month = 'Per Month',
  per_year = 'Per Year',
}

export type IOccupierCompany = Omit<ICompany, 'year_established' | 'brokerLicense' | 'isBrokerage' | 'contacts' | 'name_history' | 'notes' | 'tasks'>;

export interface IOccupierTpl {
  exists: boolean;
  type: Nullable<OccupierTplTypeEnum>;
}

export interface IOccupier extends IBaseArangoModel {
  active: boolean; // no need to merge
  address: IOccupierAddress;
  company: IOccupierCompany;
  comparable: string[]; // comparable ids
  contacts: IOccupierContact[];
  details: IDetails;
  floor: Nullable<number>;
  inventory_per_sf: Nullable<number>;
  inventory_total: Nullable<number>;
  land_size: Nullable<number>;
  lastPeriod: Nullable<IOccupierSchedulePeriod>; // no need to merge
  lease: IOccupierLease;
  lease_expiration: Nullable<string>; // ISO date
  legacy_id: Nullable<string>;
  location: IOccupierLocation;
  locked: boolean; // no need to merge
  logo: Nullable<string>;
  name: string;
  notes: string[];
  occupancy_type: OccupancyTypeEnum;
  tpl: IOccupierTpl;
  ofRecord: Nullable<IOccupierOfRecord>; // no need to merge
  office_size: Nullable<number>;
  permissions: IPermissions; // ask if need to merge
  possession_date: Nullable<string>; // ISO date
  property: Nullable<IProperty>;
  propertyId: Nullable<string>;
  rent_schedules: Nullable<string[]>;
  schedule: Nullable<IOccupierSchedule>;
  site: IOccupierSite; // need to check, may not need to select during merge process
  square_feet: Nullable<number>;
  suite: Nullable<string>;
  tasks: string[];
  use_types: IUseType[];
  vacated: boolean; // merged
}
